export interface IFrontdeskLocations {
    frontdeskLocations: IFrontdeskLocation[];
}

export interface IFrontdeskLocation {
    id: string;
    name: string;
    isDefault: boolean;
    frontdeskLocationAccessRights: IFrontdeskLocationAccessRight[];
}

export interface IFrontdeskLocationAccessRight {
    id: string;
    ticketId: string;
    name: string;
    accessType: FrontDeskLocationAccessType;
    eventCheckIn: boolean;
}

export interface IEditFrontdeskLocation {
    id: string;
    name: string;
    frontdeskLocationAccessRights: IEditFrontdeskLocationAccessRight[];
    frontdeskLocationAccessRightsToDelete: string[];
}

export interface IEditFrontdeskLocationAccessRight {
    id: string;
    ticketId: string;
    accessType: FrontDeskLocationAccessType;
    eventCheckIn: boolean;
}

export interface IAddFrontdeskLocation {
    name: string;
    frontdeskLocationAccessRights: IAddFrontdeskLocationAccessRight[];
}

export interface IAddFrontdeskLocationAccessRight {
    ticketId?: string;
    accessType?: FrontDeskLocationAccessType;
    eventCheckIn?: boolean;
}

export enum FrontDeskLocationAccessType {
    Matching,
    All
}
